import * as validationFuncs from '@common-ui-library/shared';
import { useI18n } from '@common-ui-library/shared';
import { TextField, Divider, Switch } from '@common-ui-library/atom';
import { Dropdown } from '@common-ui-library/molecule';



import { ValueField } from '../../Utils/types';
import { ROLES, DEFAULT_PROFESSION_ID } from '../../Utils/constants';

export const providerDefaultValues = {
  [ROLES.ELEOS_ADMINPORTAL_ADMIN]: false,
  is_excluded_metrics: false,
  profession: DEFAULT_PROFESSION_ID,
}

const ProviderFields = (isAddEntityOpen: boolean) => {
  const { t } = useI18n();
  const baseFieldProps = {
    fullWidth: true,
    variant: 'outlined',
    size: 'small',
    sx: {
      '& .MuiInputBase-root': {
        borderRadius: '8px',
        padding: '0px 12px',
        border: '1px solid rgba(33, 33, 33, 0.23)',
      },
      '& .MuiInputBase-input': {
        letterSpacing: '0.15px',
        lineHeight: '24px',
      },
      '& .MuiFormLabel-root': {
        letterSpacing: '0.1px',
        lineHeight: '157%',
        fontWeight: 500,
        fontFamily: 'Poppins',
      },
      gap: 1,
      color: '#212121',
    },
  };

  return [
    {
      label: t('labels.name'),
      component: TextField,
      componentProps: {
        ...baseFieldProps,
        name: 'name',
      },
      errorText: true,
      isRequired: true,
      eventHandlers: ['onChange', 'onBlur'],
    },
    {
      label: t('labels.email'),
      component: TextField,
      componentProps: {
        ...baseFieldProps,
        name: 'email',
        disabled: !isAddEntityOpen,
        ...(isAddEntityOpen && {
          inputProps: {
            pattern: '[^@]+@[^@]+\\.[a-zA-Z]{2,}$', // HTML5 validation pattern
            minLength: 5,
            maxLength: 80,
          },
        }),
      },
      errorText: true,
      validationFunction: validationFuncs['emailValidation'],
      isRequired: true,
      eventHandlers: !!isAddEntityOpen && ['onChange', 'onBlur'],
    },
    {
      label: t('labels.profession'),
      component: Dropdown,
      componentProps: {
        ...baseFieldProps,
        name: 'profession',
        fullWidth: true,
        placeholder: t('placeholders.selectList'),
      },
      isRequired: true,
      valueField: ValueField.DEFAULT_VALUE,
      optionsKey: 'profession_choices',
      eventHandlers: ['handleChangeOption'],
    },
    {
      label: t('labels.site'),
      component: Dropdown,
      componentProps: {
        ...baseFieldProps,
        name: 'site',
        fullWidth: true,
        placeholder: t('placeholders.selectList'),
      },
      isRequired: true,
      valueField: ValueField.DEFAULT_VALUE,
      optionsKey: 'site_choices',
      eventHandlers: ['handleChangeOption'],
    },
    {
      label: t('labels.supervisor'),
      component: TextField,
      componentProps: {
        ...baseFieldProps,
        name: 'supervisor',
      },
      eventHandlers: ['onChange'],
    },
    {
      label: t('labels.program'),
      component: TextField,
      componentProps: {
        ...baseFieldProps,
        name: 'program',
      },
      eventHandlers: ['onChange'],
    },
    {
      label: t('labels.phoneNumber'),
      component: TextField,
      componentProps: {
        ...baseFieldProps,
        name: 'phone',
      },
      errorText: true,
      validationFunction: validationFuncs['phoneNumberValidation'],
      eventHandlers: ['onChange', 'onBlur'],
    },
    {
      label: t('labels.excludeFromMetrics'),
      displaySingleLine: true,
      component: Switch,
      componentProps: {
        name: 'is_excluded_metrics',
        sx: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginLeft: 'auto',
        },
      },
      valueField: ValueField.CHECKED,
      fullGridWidth: true,
      eventHandlers: ['onChange'],
    },
    {
      label: t('labels.adminInOrg'),
      subLabel: t('labels.adminAccessDescription'),
      displaySingleLine: true,
      component: Switch,
      componentProps: {
        name: ROLES.ELEOS_ADMINPORTAL_ADMIN,
        sx: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginLeft: 'auto',
        },
      },
      valueField: ValueField.CHECKED,
      fullGridWidth: true,
      eventHandlers: ['onChange'],
    }
  ];
};

export default ProviderFields;
